import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { Apollo } from '@/core/services';
import { GET_SUBSCRIPTION_STATUS } from '@/modules/system/system-settings-status/graphql/Queries';

// system_settings_status row that decides who manages products (1 = Smart WMS, 0 = shop admin)
export const WMS_MANAGES_PRODUCTS_KEY = 'wms_manages_products';

// status comes as 1/0 or true/false; only an explicit off value counts as OFF (missing / unknown = ON, as in the API)
export const toWmsFlag = (status: unknown): boolean => {
    if (status === false || status === 0) {
        return false;
    }
    return !['0', 'false', 'off', 'no'].includes(String(status).trim().toLowerCase());
};

export interface WmsInfo {
    wmsManagesProducts: boolean;
    wmsSettingLoaded: boolean;
}

@Module
export default class WmsModule extends VuexModule implements WmsInfo {
    // ON by default (and when the row is missing): products come from Smart WMS
    wmsManagesProducts = true;
    wmsSettingLoaded = false;

    get getWmsManagesProducts(): boolean {
        return this.wmsManagesProducts;
    }

    get isWmsSettingLoaded(): boolean {
        return this.wmsSettingLoaded;
    }

    @Mutation
    SET_WMS_MANAGES_PRODUCTS(value: boolean) {
        this.wmsManagesProducts = value;
        this.wmsSettingLoaded = true;
    }

    @Action({ rawError: true })
    async fetchWmsSetting() {
        const { data } = await Apollo.query({
            query: GET_SUBSCRIPTION_STATUS,
            fetchPolicy: 'network-only'
        });
        const rows = (data && data.system_settings_status) || [];
        const row = rows.find((item: Record<any, any>) => item.key == WMS_MANAGES_PRODUCTS_KEY);
        const value = row ? toWmsFlag(row.status) : true;
        this.context.commit('SET_WMS_MANAGES_PRODUCTS', value);
        return value;
    }
}
